<template>
	<div class="c-search-bar">
		<form class="c-search-bar__inner" @submit.prevent="onSubmit">
			<div class="c-search-bar__query">
				<InputText v-model="query" placeholder="Search"></InputText>
				<span class="c-spinner" v-if="processing"></span>
				<span
					class="c-search-bar__clear"
					v-if="hasFilters"
					@click="clearFilters"
				>
					Clear Filters
				</span>
			</div>
			<article>
				<button
					v-if="multiplayer && !brandList"
					:class="[
						'btn',
						{ inactive: isAllowed === false },
						'key-categories',
						{ active: params.categories.length > 0 },
					]"
					type="button"
					ref="refCategories"
					@click="flip('popupCategories')"
					v-tooltip="tooltip(`Search by niches`)"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3M16.7712 13.2709C16.1341 15.2995 14.2389 16.7711 12 16.7711C9.23858 16.7711 7 14.5325 7 11.7711C7 9.53228 8.47145 7.63713 10.5 7M14 10H18L21.5 6.5L18.5 5.5L17.5 2.5L14 6V10ZM14 10L12 12"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<span> Niches </span>
				</button>
				<button
					v-if="!multiplayer && !brandList"
					:class="[
						'btn',
						{ inactive: isAllowed === false },
						'key-tags',
						{ active: !!params.tag },
					]"
					type="button"
					ref="refTags"
					@click="flip('popupTags')"
					v-tooltip="tooltip(`Search by tags`)"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M2 7C2 5.89543 2.89543 5 4 5H15.0801C15.664 5 16.2187 5.25513 16.5986 5.69842L20.8844 10.6984C21.5263 11.4474 21.5263 12.5526 20.8844 13.3016L16.5986 18.3016C16.2187 18.7449 15.664 19 15.0801 19H4C2.89543 19 2 18.1046 2 17V7Z"
							stroke="currentColor"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<circle
							stroke-width="1.5"
							cx="15"
							cy="12"
							r="1.5"
							stroke="currentColor"
						/>
					</svg>

					<span> Tags </span>
				</button>
				<button
					:class="['btn', 'key-active-ads', { active: params.activeAds }]"
					type="button"
					ref="refActiveAds"
					@click="flip('popupActiveAds')"
					v-tooltip="tooltip(`Search by currently running Ads`)"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
						class="lucide lucide-activity"
					>
						<path d="M22 12h-4l-3 9L9 3l-3 9H2" />
					</svg>
					<span> Active ads </span>
				</button>
				<button
					v-if="!brandList"
					:class="[
						'btn',
						'key-networks',
						{ active: params.networks && params.networks.length > 0 },
					]"
					type="button"
					ref="refNetwork"
					@click="flip('popupNetwork')"
					v-tooltip="tooltip(`Search by Ad networks(Facebook, Tiktok, etc)`)"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9.75515 12.1387C10.0308 11.5323 10.1686 11.2291 10.3627 10.9694C10.5348 10.7392 10.7392 10.5348 10.9694 10.3627C11.2291 10.1686 11.5323 10.0308 12.1387 9.75515L16 8L14.2448 11.8613C13.9692 12.4677 13.8314 12.7709 13.6373 13.0306C13.4652 13.2608 13.2608 13.4652 13.0306 13.6373C12.7709 13.8314 12.4677 13.9692 11.8613 14.2448L8 16L9.75515 12.1387Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<span> Platforms </span>
				</button>
				<button
					v-if="!boards && !brands && !brandList"
					:class="[
						'btn',
						'key-brands',
						{ active: params.brands && params.brands.length > 0 },
					]"
					type="button"
					ref="refBrand"
					@click="flip('popupBrand')"
					v-tooltip="tooltip(`Search by Brands & creators`)"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M21 8L18 4H6L3 8M21 8V9C21 9.8885 20.6137 10.6868 20 11.2361M21 8H3M3 8V9C3 9.8885 3.38625 10.6868 4 11.2361M15 9C15 10.6569 16.3431 12 18 12C18.7684 12 19.4692 11.7111 20 11.2361M15 9V8M15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9M9 9C9 10.6569 7.65685 12 6 12C5.23165 12 4.53076 11.7111 4 11.2361M9 9V8M14 20L14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17L10 20M4 11.2361V20H20V11.2361"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<span> Brands </span>
				</button>
				<button
					:class="[
						'btn',
						'key-media-type',
						{ active: params.mediaType !== 'all' },
					]"
					ref="refMediaType"
					type="button"
					@click="flip('popupMediaType')"
					v-tooltip="tooltip(`Search by Media types, eg video, image, etc`)"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M3 3V2C2.44772 2 2 2.44772 2 3H3ZM15 3H16C16 2.44772 15.5523 2 15 2V3ZM14 9V10H16V9H14ZM3 15H2C2 15.5523 2.44772 16 3 16V15ZM9 16H10V14H9V16ZM9 9V8C8.44772 8 8 8.44772 8 9H9ZM21 9H22C22 8.44772 21.5523 8 21 8V9ZM9 21H8C8 21.5523 8.44772 22 9 22V21ZM21 21V22C21.5523 22 22 21.5523 22 21H21ZM2.4453 11.1679C1.98577 11.4743 1.8616 12.0952 2.16795 12.5547C2.4743 13.0142 3.09517 13.1384 3.5547 12.8321L2.4453 11.1679ZM6 10L6.5547 9.16795C6.2188 8.94402 5.7812 8.94402 5.4453 9.16795L6 10ZM8.4453 12.8321C8.90483 13.1384 9.5257 13.0142 9.83205 12.5547C10.1384 12.0952 10.0142 11.4743 9.5547 11.1679L8.4453 12.8321ZM6.25 5.25C5.69772 5.25 5.25 5.69772 5.25 6.25C5.25 6.80228 5.69772 7.25 6.25 7.25V5.25ZM6.26 7.25C6.81228 7.25 7.26 6.80228 7.26 6.25C7.26 5.69772 6.81228 5.25 6.26 5.25V7.25ZM14 13.4L14.5795 12.585C14.2746 12.3682 13.874 12.3397 13.5415 12.5113C13.2089 12.6829 13 13.0258 13 13.4H14ZM14 16.6H13C13 16.9742 13.2089 17.3171 13.5415 17.4887C13.874 17.6603 14.2746 17.6318 14.5795 17.415L14 16.6ZM16.25 15L16.8295 15.815C17.0933 15.6274 17.25 15.3237 17.25 15C17.25 14.6763 17.0933 14.3726 16.8295 14.185L16.25 15ZM3 4H15V2H3V4ZM14 3V9H16V3H14ZM2 3V15H4V3H2ZM3 16H9V14H3V16ZM9 10H21V8H9V10ZM8 9V21H10V9H8ZM9 22H21V20H9V22ZM20 9V21H22V9H20ZM3.5547 12.8321L6.5547 10.8321L5.4453 9.16795L2.4453 11.1679L3.5547 12.8321ZM5.4453 10.8321L8.4453 12.8321L9.5547 11.1679L6.5547 9.16795L5.4453 10.8321ZM5.5 6.25C5.5 5.83579 5.83579 5.5 6.25 5.5V7.5C6.94036 7.5 7.5 6.94036 7.5 6.25H5.5ZM6.25 5.5C6.66421 5.5 7 5.83579 7 6.25H5C5 6.94036 5.55964 7.5 6.25 7.5V5.5ZM7 6.25C7 6.66421 6.66421 7 6.25 7V5C5.55964 5 5 5.55964 5 6.25H7ZM6.25 7C5.83579 7 5.5 6.66421 5.5 6.25H7.5C7.5 5.55964 6.94036 5 6.25 5V7ZM6.25 7.25H6.26V5.25H6.25V7.25ZM13 13.4V16.6H15V13.4H13ZM14.5795 17.415L16.8295 15.815L15.6705 14.185L13.4205 15.785L14.5795 17.415ZM16.8295 14.185L14.5795 12.585L13.4205 14.215L15.6705 15.815L16.8295 14.185Z"
							fill="currentColor"
						/>
					</svg>
					<span> Asset </span>
				</button>

				<button
					:class="['btn', 'key-sort', { active: params.sort !== 'all' }]"
					ref="refSort"
					type="button"
					@click="flip('popupSort')"
					v-tooltip="tooltip(`Sort by Active days, Ad reach and more`)"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M6.29289 3.29289C6.68342 2.90237 7.31658 2.90237 7.70711 3.29289L11.7071 7.29289C12.0976 7.68342 12.0976 8.31658 11.7071 8.70711C11.3166 9.09763 10.6834 9.09763 10.2929 8.70711L8 6.41421V20C8 20.5523 7.55228 21 7 21C6.44772 21 6 20.5523 6 20V6.41421L3.70711 8.70711C3.31658 9.09763 2.68342 9.09763 2.29289 8.70711C1.90237 8.31658 1.90237 7.68342 2.29289 7.29289L6.29289 3.29289ZM16 17.5858V4C16 3.44772 16.4477 3 17 3C17.5523 3 18 3.44772 18 4V17.5858L20.2929 15.2929C20.6834 14.9024 21.3166 14.9024 21.7071 15.2929C22.0976 15.6834 22.0976 16.3166 21.7071 16.7071L17.7071 20.7071C17.3166 21.0976 16.6834 21.0976 16.2929 20.7071L12.2929 16.7071C11.9024 16.3166 11.9024 15.6834 12.2929 15.2929C12.6834 14.9024 13.3166 14.9024 13.7071 15.2929L16 17.5858Z"
							fill="currentColor"
						/>
					</svg>

					<span> Sort </span>
				</button>

				<button
					:class="['btn', 'key-view']"
					ref="refView"
					type="button"
					@click="flip('popupView')"
					v-tooltip="tooltip(`Choose your Ad card display`)"
				>
					<svg
						v-if="view === 'all'"
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M2 12.0001L1.11178 11.5406C0.962741 11.8288 0.962741 12.1713 1.11178 12.4595L2 12.0001ZM22 11.9999L22.8882 12.4594C23.0373 12.1712 23.0373 11.8287 22.8882 11.5405L22 11.9999ZM2.88822 12.4595C5.16609 8.05547 8.65289 6.00002 12 6C15.3471 5.99998 18.8339 8.05537 21.1118 12.4594L22.8882 11.5405C20.3386 6.61119 16.2391 3.99997 12 4C7.76084 4.00003 3.66136 6.6113 1.11178 11.5406L2.88822 12.4595ZM1.11178 12.4595C3.66137 17.3888 7.76085 20 12 20C16.2392 20 20.3386 17.3887 22.8882 12.4594L21.1118 11.5405C18.8339 15.9445 15.3471 18 12 18C8.65288 18 5.16609 15.9446 2.88822 11.5406L1.11178 12.4595ZM14 12C14 13.1046 13.1046 14 12 14V16C14.2091 16 16 14.2091 16 12H14ZM12 14C10.8954 14 10 13.1046 10 12H8C8 14.2091 9.79086 16 12 16V14ZM10 12C10 10.8954 10.8954 10 12 10V8C9.79086 8 8 9.79086 8 12H10ZM12 10C13.1046 10 14 10.8954 14 12H16C16 9.79086 14.2091 8 12 8V10Z"
							fill="currentColor"
						/>
					</svg>
					<svg
						v-if="view === 'md'"
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M10.607 4.09497C10.0598 4.16981 9.67687 4.67407 9.75172 5.22126C9.82656 5.76845 10.3308 6.15137 10.878 6.07652L10.607 4.09497ZM22 11.9999L22.8882 12.4594C23.0373 12.1712 23.0373 11.8287 22.8882 11.5405L22 11.9999ZM19.5181 14.02C19.1738 14.4519 19.2449 15.081 19.6767 15.4253C20.1086 15.7695 20.7378 15.6985 21.082 15.2666L19.5181 14.02ZM3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L3.70711 2.29289ZM20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L20.2929 21.7071ZM2 12L1.11178 11.5406C0.962741 11.8287 0.962741 12.1713 1.11178 12.4594L2 12ZM7.18937 7.48108C7.65206 7.17953 7.78268 6.55998 7.48113 6.09729C7.17957 5.6346 6.56002 5.50398 6.09733 5.80554L7.18937 7.48108ZM17.9027 18.1944C18.3654 17.8928 18.496 17.2733 18.1944 16.8106C17.8929 16.3479 17.2733 16.2173 16.8106 16.5188L17.9027 18.1944ZM10.878 6.07652C14.5691 5.57166 18.5835 7.57111 21.1118 12.4594L22.8882 11.5405C20.0548 6.06251 15.3042 3.45251 10.607 4.09497L10.878 6.07652ZM21.082 15.2666C21.7445 14.4356 22.3505 13.4991 22.8882 12.4594L21.1118 11.5405C20.6305 12.471 20.0946 13.2967 19.5181 14.02L21.082 15.2666ZM12 14C10.8954 14 10 13.1046 10 12H8C8 14.2091 9.79086 16 12 16V14ZM2.29289 3.70711L9.17157 10.5858L10.5858 9.17157L3.70711 2.29289L2.29289 3.70711ZM10 12C10 11.4474 10.2228 10.9488 10.5858 10.5858L9.17157 9.17157C8.44881 9.89434 8 10.8957 8 12H10ZM9.17157 10.5858L13.4142 14.8284L14.8284 13.4142L10.5858 9.17157L9.17157 10.5858ZM13.4142 14.8284L20.2929 21.7071L21.7071 20.2929L14.8284 13.4142L13.4142 14.8284ZM13.4142 13.4142C13.0512 13.7772 12.5526 14 12 14V16C13.1043 16 14.1057 15.5512 14.8284 14.8284L13.4142 13.4142ZM2.29289 3.70711L20.2929 21.7071L21.7071 20.2929L3.70711 2.29289L2.29289 3.70711ZM2.88822 12.4594C4.0635 10.1872 5.56387 8.5405 7.18937 7.48108L6.09733 5.80554C4.14612 7.07724 2.42496 9.00172 1.11178 11.5406L2.88822 12.4594ZM1.11178 12.4594C3.00295 16.1158 5.74306 18.4987 8.78165 19.486C11.8271 20.4756 15.0837 20.0316 17.9027 18.1944L16.8106 16.5188C14.4793 18.0383 11.8492 18.3798 9.39972 17.5839C6.94336 16.7858 4.58027 14.812 2.88822 11.5406L1.11178 12.4594Z"
							fill="black"
						/>
					</svg>
					<svg
						v-if="view === 'sm'"
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M4 12.9381C8.64513 17.8771 15.3548 17.8771 20 12.9381M4 7.70431C6.32258 5.23479 9.16131 4.00002 12 4C14.8387 3.99998 17.6774 5.23469 20 7.70413M12 16.75V20M8.50004 16.25L7.00004 18.7321M15.5 16.25L17 18.7321"
							stroke="black"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<span> Display </span>
				</button>
			</article>
		</form>
		<PopupCategories
			v-if="hasMounted && !brandList && multiplayer"
			buttonSelector=".key-categories"
			:target="refCategories"
			:active="popupCategories"
			@onClose="popupCategories = false"
			:tags="activeCategories"
			v-model="params.categories"
		>
		</PopupCategories>
		<PopupTags
			v-if="hasMounted && !multiplayer && !brandList"
			buttonSelector=".key-tags"
			:target="refTags"
			:active="popupTags"
			@onClose="popupTags = false"
			v-model="params.tag"
		>
		</PopupTags>
		<PopupFilter
			v-if="hasMounted"
			buttonSelector=".key-active-ads"
			:target="refActiveAds"
			:active="popupActiveAds"
			@onClose="popupActiveAds = false"
		>
			<article>
				<p class="article-text-sm">
					Filters ads that are running right now. Works for Facebook ads only.
				</p>
			</article>
			<InputRadio
				v-model="params.activeAds"
				:options="activeAdTypes"
			></InputRadio>
		</PopupFilter>
		<PopupFilter
			v-if="hasMounted && !brandList"
			buttonSelector=".key-networks"
			:target="refNetwork"
			:active="popupNetwork"
			@onClose="popupNetwork = false"
		>
			<!-- <article>
        <p class="article-text-sm">Search by Ad Platforms.</p>
      </article> -->
			<InputNetworks
				v-model="params.networks"
				:options="networkTypes"
				:multiplayer="multiplayer"
			></InputNetworks>
		</PopupFilter>
		<PopupBrand
			:multiplayer="multiplayer"
			v-if="hasMounted && !boards && !brands && !brandList"
			buttonSelector=".key-brands"
			:target="refBrand"
			:active="popupBrand"
			@onClose="popupBrand = false"
			v-model="params.brands"
		>
			<!-- <article>
        <p class="article-text-sm">Search by specific brands.</p>
      </article>
      <InputBrand v-model="params.brands"></InputBrand> -->
		</PopupBrand>
		<PopupFilter
			v-if="hasMounted"
			buttonSelector=".key-media-type"
			:target="refMediaType"
			:active="popupMediaType"
			@onClose="popupMediaType = false"
		>
			<!-- <article>
        <p class="article-text-sm">Filter by asset types.</p>
      </article> -->
			<InputRadio v-model="params.mediaType" :options="mediaTypes"></InputRadio>
		</PopupFilter>
		<PopupFilter
			v-if="hasMounted"
			buttonSelector=".key-sort"
			:target="refSort"
			:active="popupSort"
			@onClose="popupSort = false"
		>
			<article>
				<p class="article-text-sm">
					Sort by ad reach or ad running days to find winners.
				</p>
			</article>
			<InputRadio v-model="params.sort" :options="sortTypes"></InputRadio>
			<article>
				<p class="article-text-sm">
					<strong> Use sorting options to find winning Ads </strong>
				</p>
				<p class="article-text-sm">
					Sort by ad running days to find longest running ads.
					<br />
					Sort by ad reach to find ads with the biggest reach(EU only)
					<br />
					Combine this with the niches filter to find performant ads in your
					niche.
				</p>
			</article>
		</PopupFilter>
		<PopupFilter
			v-if="hasMounted"
			buttonSelector=".key-view"
			:target="refView"
			:active="popupView"
			@onClose="popupView = false"
		>
			<article>
				<p class="article-text-sm">How detailed do you want your ad cards?</p>
			</article>
			<InputRadio
				:value="view"
				@input="onViewUpdate"
				:options="viewTypes"
			></InputRadio>
		</PopupFilter>
	</div>
</template>

<script>
import InputText from '@swipekit/components/form/input-text';
import PopupFilter from '@swipekit/components/popup/popup-filter';
import PopupCategories from '@swipekit/components/popup/popup-categories';
import InputRadio from '@swipekit/components/form/input-radio';
import InputCheckboxGroup from '@swipekit/components/form/input-checkbox';
import InputNetworks from '@swipekit/components/form/input-networks';
import InputBrand from '@swipekit/components/form/input-brand';
import PopupBrand from '@swipekit/components/popup/popup-brand';
import PopupTags from '@swipekit/components/popup/popup-tags';

import api from '@swipekit/lib/api';

export default {
	components: {
		InputText,
		PopupFilter,
		PopupCategories,
		InputRadio,
		InputBrand,
		InputCheckboxGroup,
		InputNetworks,
		PopupBrand,
		PopupTags,
	},

	data: function () {
		return {
			hasMounted: false,
			query: '',

			params: {
				networks: [],
				brands: [],
				categories: [],
				mediaType: 'all',
				activeAds: 0,
				sort: 'all',
				tag: '',
			},
			activeAdTypes: [
				{
					name: 'All Ads',
					slug: 0,
				},
				{
					name: 'Active',
					slug: 1,
				},
				{
					name: 'Inactive',
					slug: 2,
				},
			],
			mediaTypes: [
				{
					name: 'All',
					slug: 'all',
				},
				{
					name: 'Video',
					slug: 'video',
				},
				{
					name: 'Image',
					slug: 'image',
				},
				{
					name: 'Carousel',
					slug: 'carousel',
				},
				{
					name: 'Text',
					slug: 'text',
				},
				{
					name: 'Youtube',
					slug: 'youtube',
				},
			],
			viewTypes: [
				{
					name: 'Compact',
					slug: 'sm',
				},
				{
					name: 'Preview',
					slug: 'md',
				},
				{
					name: 'Default',
					slug: 'all',
				},
			],
			sortTypes: [
				{
					name: 'Default',
					slug: 'all',
				},
				{
					name: 'Ad Reach - Highest first',
					slug: 'adReachFirst',
				},
				{
					name: 'Ad running days - Highest first',
					slug: 'activeDaysFirst',
				},
				{
					name: 'Saved at - Latest first',
					slug: 'createdAtFirst',
				},
				{
					name: 'Saved at - Oldest first',
					slug: 'createdAtLast',
				},
			],

			popupCategories: false,
			popupTags: false,
			popupActiveAds: false,
			popupNetwork: false,
			popupBrand: false,
			popupMediaType: false,
			popupView: false,
			popupSort: false,
		};
	},

	watch: {
		query: function () {
			//this.runFilter();
		},
		// view: function () {
		//  this.onViewUpdate();
		// },
		params: {
			deep: true,
			handler: function () {
				this.onSearch();
			},
		},
		value: {
			immediate: true,
			deep: true,
			handler: function () {
				if (!this.value) {
					return;
				}
				if (this.value.query) {
					this.query = this.value.query;
				}
				if (this.value.activeAds) {
					this.params.activeAds = this.value.activeAds;
				}
				if (this.value.mediaType) {
					this.params.mediaType = this.value.mediaType;
				}
				if (this.value.networks) {
					this.params.networks = this.value.networks;
				}
				if (this.value.categories) {
					this.params.categories = this.value.categories;
				}
				if (this.value.sort) {
					this.params.sort = this.value.sort;
				}
			},
		},
	},

	props: {
		value: {},
		processing: {
			type: Boolean,
			default: false,
		},
		activeCategories: {
			type: Array,
			default: function () {
				return [];
			},
		},
		multiplayer: {
			type: Boolean,
			default: false,
		},
		brandList: {
			type: Boolean,
			default: false,
		},
		brands: {
			type: Boolean,
			default: false,
		},
		boards: {
			type: Boolean,
			default: false,
		},
		view: {
			default: 'all',
		},
	},

	computed: {
		showSidebar: function () {
			return this.$store.getters['app/showSidebar'];
		},
		networkTypes: function () {
			let networkTypes = [
				{
					name: 'Facebook',
					slug: 'facebook',
				},
				{
					name: 'Instagram',
					slug: 'instagram',
				},
				{
					name: 'Instagram Feed',
					slug: 'instagram-feed',
				},
				{
					name: 'Instagram Reel',
					slug: 'instagram-reel',
				},
				{
					name: 'Tiktok',
					slug: 'tiktok',
				},
				{
					name: 'Threads',
					slug: 'threads',
				},
				{
					name: 'Whatsapp',
					slug: 'whatsapp',
				},
				{
					name: 'Linkedin',
					slug: 'linkedin',
				},
				{
					name: 'Google',
					slug: 'google',
				},
			];

			if (!this.multiplayer) {
				networkTypes.push({
					name: 'Manual upload',
					slug: 'upload-custom',
				});
			}

			return networkTypes;
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		refCategories: function () {
			return this.$refs.refCategories;
		},
		refTags: function () {
			return this.$refs.refTags;
		},
		refActiveAds: function () {
			return this.$refs.refActiveAds;
		},
		refNetwork: function () {
			return this.$refs.refNetwork;
		},
		refBrand: function () {
			return this.$refs.refBrand;
		},
		refMediaType: function () {
			return this.$refs.refMediaType;
		},
		refView: function () {
			return this.$refs.refView;
		},
		refSort: function () {
			return this.$refs.refSort;
		},
		hasFilters: function () {
			if (this.params.networks.length > 0) {
				return true;
			}
			if (this.params.brands.length > 0) {
				return true;
			}
			if (this.params.mediaType !== 'all') {
				return true;
			}
			if (this.params.activeAds !== 0) {
				return true;
			}
			if (this.params.categories.length > 0) {
				return true;
			}
			if (this.params.sort !== 'all') {
				return true;
			}
			if (this.params.tag) {
				return true;
			}

			return false;
		},
		isAllowed: function () {
			if (!this.activeCategories) {
				return;
			}
			if (this.activeCategories.length === 0) {
				return;
			}
			return true;
			// let emails = ["shashwat.amin@yahoo.com", "shash@swipekit.app"];
			// if (this.user && emails.includes(this.user.email)) {
			//   return true;
			// }
			// return false;
		},
	},

	methods: {
		clearFilters: function () {
			this.params = {
				networks: [],
				brands: [],
				mediaType: 'all',
				activeAds: 0,
				categories: [],
				sort: 'all',
			};
		},
		tooltip: function (content) {
			return { content: content, offset: 10, delay: 200 };
		},
		flip: function (key) {
			this.$nextTick(() => {
				this[key] = !this[key];
			});
		},
		onSubmit: function (e) {
			e.preventDefault();
			this.onSearch();
		},
		onViewUpdate: function (e) {
			this.$emit('view', e);
		},
		onSearch: function () {
			let params = {
				query: this.query,

				...this.params,
			};

			this.$emit('search', params);
		},
	},

	mounted: async function () {
		this.hasMounted = true;
	},
};
</script>

<style lang="scss">
.c-search-bar {
	padding: var(--margin-lg) 0;
	padding-bottom: var(--margin);
	position: sticky;
	top: 0;
	z-index: 9;
	pointer-events: none;

	form .form-control {
		margin-bottom: 0;
	}

	.c-popup-filter__inner {
		> article {
			padding: var(--margin);
			padding-bottom: 0;

			.article-text-sm {
				font-size: var(--font-size-xs);
			}

			> p {
				margin-bottom: 0;
			}
		}
	}

	&__inner {
		width: calc(100% - var(--item-padding) * 2);
		//margin: 0 auto;
		margin: 0 var(--item-padding);
		z-index: 1;
		display: grid;
		grid-template-columns: 1fr; /* first component */
		grid-auto-columns: min-content; /* rest of the components */
		grid-auto-flow: column; /* align components column-wise */
		border-radius: 0.5rem;
		background-color: var(--color-bg-1);
		box-shadow: var(--item-box-shadow);
		pointer-events: initial;

		.form-group {
			padding-bottom: 0;

			input {
				border: none;
				padding: var(--margin-lg) var(--spacer-sm);
				padding-right: 24px;
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
				border-top-left-radius: 10px;
				border-bottom-left-radius: 10px;
			}
		}

		article {
			display: flex;
		}

		.btn {
			max-height: initial;
			position: relative;
			padding: 0.25rem var(--margin-lg);
			background-color: transparent;
			justify-content: flex-start;
			border-radius: 0;
			font-size: var(--font-size-sm);

			&.inactive {
				display: none;
			}

			svg {
				min-width: 20px;
			}

			span {
				margin-left: var(--margin);
				font-size: var(--font-size-xs);
				white-space: nowrap;
			}

			&:after {
				content: '';
				position: absolute;
				top: 0;
				right: 0;
				width: 1px;
				height: 100%;
				background-color: var(--color-bg-4);
			}

			&:last-of-type {
				border-top-right-radius: 10px;
				border-bottom-right-radius: 10px;

				&:after {
					content: none;
				}
			}

			&:hover,
			&:active,
			&:focus {
				background-color: transparent !important;
			}

			&.active {
				color: var(--color-primary);
			}
		}
	}

	&__query {
		position: relative;
		border-right: var(--color-bg-4) solid 1px;
	}

	&__clear {
		position: absolute;
		top: 9px;
		right: 6px;
		padding: var(--margin);
		font-family: var(--font-family-monospace);
		font-size: var(--font-size-xs);
		line-height: 1;
		letter-spacing: -0.2px;
		color: #fff;
		background-color: var(--color-primary);
		border-radius: 5px;

		cursor: pointer;
	}

	.c-input-checkbox {
		padding-bottom: 0;
		&__item {
			margin-bottom: 0.125rem;

			&:last-of-type {
				margin-bottom: 0;
			}
		}
	}

	@container (max-width: 920px) {
		&__inner {
			.btn {
				span {
					display: none;
				}
			}
		}
	}

	@container (max-width:576px) {
		top: 38px;

		&__inner {
			grid-template-rows: auto auto;

			.form-group {
				input {
					border-radius: 0;
				}
			}

			article {
				width: 100%;
				justify-content: center;

				.btn {
					flex-grow: 1;
					justify-content: center;
				}
			}
		}

		&__query {
			border-bottom: var(--color-bg-4) solid 1px;
			border-right: none;
		}
	}
}
</style>
